import { gql } from "@apollo/client";

export const GET_DISTRICT_BOUNDS = gql`
  query districtBoundsInfo($district_id: Int!) {
    Web {
      districtBoundsInfo(district_id: $district_id) {
        district_id
        bounds {
          northEast {
            lat
            lng
          }
          southWest {
            lat
            lng
          }
        }
      }
    }
  }
`;
export const GET_CITY_BOUNDS = gql`
  query getCityBoundsInfo($id: Int!) {
    Web {
      cityBoundsInfo(city_id: $id) {
        city_id
        path
        bounds {
          northEast {
            lat
            lng
          }
          southWest {
            lat
            lng
          }
        }
      }
    }
  }
`;
export const GET_DIRECTIONS_BOUNDS = gql`
  query getCityBoundsInfo($id: Int!) {
    Web {
      directionBoundsInfo(direction_id: $id) {
        direction_id
        path
        bounds {
          northEast {
            lat
            lng
          }
          southWest {
            lat
            lng
          }
        }
      }
    }
  }
`;
